import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/manipulation/remove/remove.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/manipulation/text/text.js";
import hash from "./hash.js";
import robot from "server-log-insights-tracking/src/robots.js";
import {getfiles} from "./table.js";

export default (obj, config, test = false) => {

	// map progress objects
	const proc = $("#hashform-processing"),
		heading = $(".hashform__processing-heading"),
		progress = $(".hashform__processing-progress"),
		remain = $(".hashform__processing-remain"),
		imglink = $("#hashform-images-review");
	
	// hash images when the user selects them
	obj.on("change", async function () {

		// check it is not automated, only a test bootstrap can turn this off
		if (!test && await robot()) {
			alert("Error: Hashing is not supported on this device");

		// process files
		} else {
			proc.prop("checked", true); // turn on hash progress window
			const settings = Object.assign({}, config, obj.data("hash")), // minsize/minquality are set in the CMS and only reach hash() from the form config
				files = getfiles();
			hash(obj, settings, files) // re-key the array, as previous items may have been deleted
				.then(updated => {

					// if no images are acceptable, popup
					if (updated.every(item => !item.accept)) {
						$("#hashform-quality").prop("checked", true);

					// only process if there are images
					} else if (updated.length) {

						// update file list, filter low quality
						updated.filter(item => item.accept).forEach(item => {
							item.group = config.translations.uploaded;
							files.push(item);
						});

						// if any have low quality - popup but still continue
						if (updated.some(item => !item.accept)) {
							$("#hashform-quality + .hashform__processing label[for].content__button").one("click", () => {
								$("#" + settings.next).prop("checked", true).trigger("change");
							});
							$("#hashform-quality").prop("checked", true);

						// move to next screen
						} else {
							$("#" + settings.next).prop("checked", true).trigger("change");
						}
						imglink.removeClass("hashform__link--hide");
					}

					// close the progress popup
					proc.prop("checked", false);

					// debug hashes to console
					if (config.debug) {
						console.log(files);
					}
				})
				.catch(e => {
					proc.prop("checked", false);
					$("#hashform-error").prop("checked", true);
				});
		}
	});

	obj.on("hash.progress", e => {
		heading.text(Math.round(e.detail.percentage) + "%");
		progress.prop("value", e.detail.percentage);
		remain.text(Math.round(e.detail.remain) + " secs");
	});
}